/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentStreetShortTermRentalsProps {
  streetName: string;
  cityName: string;
}

export const ContentStreetShortTermRentals = ({
  streetName,
  cityName,
}: ContentStreetShortTermRentalsProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Short term rentals in ${streetName}, ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Looking for short term rentals in ${streetName}? Kamernet makes it easy to
        book a short stay rental in ${streetName} without the usual hassle. We offer
        short term accommodation in ${streetName} for students and traveling
        professionals, with options starting from 30 days. Whether you need
        temporary housing in ${streetName} for work, study, or travel, there are
        plenty of flexible choices. Find short term apartments, short stay
        studios or rooms in ${streetName} for short term that suit your needs and
        budget. You can rent short term apartments in ${streetName} or rent a flat in
        ${streetName} for short term and feel at home from day one.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Tijdelijk Huren in ${streetName}, ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Op zoek naar tijdelijk huren in ${streetName}? Kamernet maakt het eenvoudig
        om een tijdelijke woning in ${streetName} te vinden, zonder gedoe. Wij bieden
        tijdelijke huisvesting in ${streetName} voor studenten en reizende
        professionals, met verblijfsopties vanaf 30 dagen. Of je nu tijdelijk
        woont in ${streetName} voor werk, studie of een reis, er zijn volop flexibele
        mogelijkheden. Je vindt tijdelijke appartementen, short stay studio’s of
        kamers in ${streetName} die passen bij jouw wensen en budget. Je kunt een
        tijdelijk appartement huren in ${streetName} of een flat tijdelijk huren in
        ${streetName} en voel je vanaf dag één thuis.`}
      </Typography>
    </React.Fragment>
  );
};
